import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Link45deg,
  GeoAltFill,
  TelephoneFill,
  EnvelopeFill,
} from "react-bootstrap-icons";

import { PageLayout } from "../../common/page-layout/page-layout";
import { LoginModal } from "../../common/modal/login-model";

export const Login = ({ requiredLogin = false }) => {
  const intl = useIntl();

  return (
    <>
      <PageLayout title={intl.formatMessage({ id: "page.login.title" })}>
        <>
          <h1>
            <FormattedMessage id="page.login.infos.block.title" />
          </h1>
          <p>
            <FormattedMessage id="page.login.infos.block.p1" />
          </p>
          <p>
            <FormattedMessage id="page.login.infos.block.p2" />
          </p>
          <ul className="list-unstyled ms-4">
            <li className="mb-2">
              <span className="text-ki-green me-2">
                <Link45deg />
              </span>
              <span>
                <a href="https://ki-group.hu/" target="_blank" rel="noreferrer">
                  https://ki-group.hu/
                </a>
              </span>
            </li>
            <li className="mb-2">
              <span className="text-ki-green me-2">
                <GeoAltFill />
              </span>
              <span>1222, Budapest, Nagytétényi út 102.</span>
            </li>
            <li className="mb-2">
              <span className="text-ki-green me-2">
                <TelephoneFill /> (
                <FormattedMessage id="page.login.infos.block.office" />)
              </span>
              <span>+36 1 208 6030</span>
            </li>
            <li className="mb-2">
              <span className="text-ki-green me-2">
                <TelephoneFill /> (
                <FormattedMessage id="page.login.infos.block.customerservice" />
                )
              </span>
              <span>+36 1 208 2898</span>
            </li>
            <li className="mb-2">
              <span className="text-ki-green me-2">
                <EnvelopeFill />
              </span>
              <span>
                <a href="mailto:office@ki-group.hu">office@ki-group.hu</a>
              </span>
            </li>
          </ul>
        </>
      </PageLayout>
      {requiredLogin ? <LoginModal /> : null}
    </>
  );
};

Login.propTypes = {
  requiredLogin: PropTypes.bool,
};
